import { FORMAL_QUOTE_OPTIONS } from 'formal_quote/options';

export const selectFormalQuote = (state) => state.formalQuote;

export const selectDataForRecommendedProduct = (state) => {
  const { formData } = state.formalQuote;

  const getLicenseType = () => {
    const { portability_option, license_type, license_scope } = formData;

    // Network license always results in Network Computer Locked
    if (license_type === 'network') {
      return 'Network Computer Locked';
    }

    // Standalone license depends on portability option
    if (license_type === 'standalone' && portability_option === 'not_needed') {
      return 'Standalone Computer Locked';
    }
    if (license_type === 'standalone' && portability_option === 'any_machine') {
      return 'Standalone Locked to USB Dongle';
    }

    return '';
  };

  const data = {
    productName: FORMAL_QUOTE_OPTIONS.software_type[formData.software_type] || '',
    licenseScope:
      FORMAL_QUOTE_OPTIONS.license_scope[formData.license_scope]?.label || '',
    numberOfUsers: (() => {
      const val = formData.number_of_users;
      if (FORMAL_QUOTE_OPTIONS.number_of_users[val]) return FORMAL_QUOTE_OPTIONS.number_of_users[val];
      const num = parseInt(val, 10);
      return (!isNaN(num) && num > 0) ? `${num} User${num === 1 ? '' : 's'}` : '1 User';
    })(),
    numberOfUsersLabel: formData.license_scope === 'site'
      ? 'Potential Number of Users'
      : formData.license_scope === 'standard'
        ? 'Number of Licenses'
        : 'Number of Users',
    licenseType: getLicenseType(),
    deliveryMethod: FORMAL_QUOTE_OPTIONS.delivery_method[formData.delivery_method] || '',
    looking_for: formData.looking_for,
  };

  return data;
};
